import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { notification } from "antd";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault(); // Prevents the page from reloading

    if (!email.trim()) {
      notification.error({
        message: "Opps!",
        description: "Please enter a valid email",
      });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("https://stage.apicanada.blaccdot.com/auth/forgetPassword", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      setLoading(false);

      if (!response.ok) {
        throw new Error(data?.message || "Failed to send password reset email.");
      }

      if (data?.data?.success) {
        notification.success({
          message: "Success",
          description: data.data.message || "Password reset instructions sent successfully!",
        });
      } else {
        notification.error({
          message: "Opps!",
          description: data?.data?.message || "Failed to send password reset email.",
        });
      }
    } catch (error) {
      setLoading(false);
      notification.error({
        message: "Opps!",
        description: error.message || "Something went wrong. Please try again later.",
      });
    }
  };

  return (
    <div className="forgot-password-wrapper d-flex align-items-center justify-content-center vh-100">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} className="shadow-lg p-5 bg-white rounded">
            <h2 className="text-dark fw-bold text-center">Forgot Password</h2>
            <p className="text-muted text-center">
              Enter your email address, and we'll send you reset instructions.
            </p>

            <Form onSubmit={handleChangePassword}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Control
                  type="email"
                  placeholder="Enter E-mail Address"
                  className="p-2"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <Button type="submit" className="w-100" variant="primary" disabled={loading}>
                {loading ? "Sending..." : "Send New Password"}
              </Button>
            </Form>

        <div className="text-center mt-3">
        <a href="/login" className="text-decoration-none text-primary">
          Back to Login
        </a>
        </div> 
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPassword;


{/* <div className="text-center mt-3">
<a href="/login" className="text-decoration-none text-primary">
  Back to Login
</a>
</div> */}
// import React, { useState } from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import { useDispatch } from "react-redux";
// import { forgotPasswordAction } from "../../store/action/common/forgotPasswordAction";
// import { notification } from "antd";

// const ForgotPassword = () => {
//   const dispatch = useDispatch();
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleChangePassword = (event) => {
//     event.preventDefault(); // Prevent page reload

//     if (!email.trim()) {
//       notification.error({
//         message: "Error",
//         description: "Please enter a valid email",
//       });
//       return;
//     }

//     setLoading(true); // Show loading state

//     const payload = {
//       email: email,
//       onSuccess: (response) => {
//         setLoading(false);
//         if (response?.data?.success) {
//           notification.success({
//             message: "Success",
//             description: "Password sent successfully!",
//           });
//         } else {
//           notification.error({
//             message: "Error",
//             description: response?.data?.message || "Failed to send password.",
//           });
//         }
//       },
//       onFailure: (error) => {
//         setLoading(false);
//         notification.error({
//           message: "Error",
//           description: error || "Something went wrong.",
//         });
//       },
//     };

//     dispatch(forgotPasswordAction(payload));
//   };

//   return (
//     <div className="forgot-password-wrapper d-flex align-items-center justify-content-center vh-100">
//       <Container>
//         <Row className="justify-content-center">
//           <Col md={6} className="shadow-lg p-5 bg-white rounded">
//             <h2 className="text-dark fw-bold">Forgot Password</h2>
//             <p className="text-muted">
//               Enter your e-mail address, and we'll give you reset instructions.
//             </p>
//             <Form onSubmit={handleChangePassword}>
//               <Form.Group className="mb-3" controlId="formBasicEmail">
//                 <Form.Control
//                   type="email"
//                   placeholder="Enter E-mail Address"
//                   className="p-2"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </Form.Group>
//               <Button type="submit" className="w-100" variant="primary" disabled={loading}>
//                 {loading ? "Sending..." : "Send New Password"}
//               </Button>
             
//             </Form>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };

// export default ForgotPassword;



// {/* <div className="text-center mt-3">
// <a href="/login" className="text-decoration-none text-primary">
//   Back to Login
// </a>
// </div> */}
